<script setup>
</script>

<template>
  <div class="glass-bright rounded-full px-5 py-2 flex items-center gap-4">
    <img src="/img/logo/Logo-mg.png" class="h-12" alt="migas" />
    <img src="/img/logo/blu.png" class="h-12" alt="blu" />
  </div>
</template>

<style scoped>
</style>
